import { SapContractFeeSnapshot } from '@/components/Approval/@components/SapContractFee';
import { parseSapContractFeeContent } from '@/utils/approval/sapContractFee';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 167 SAP 도급비 수수료 정산 — 저장 content 그대로(레거시 조회와 동일) */
const SapContractFeeSlot = ({ data }: ContentExtraProps) => {
  const content = parseSapContractFeeContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SapContractFeeSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SapContractFeeSlot;
